import * as FormUtils from 'utils/form';

import { isValidTickSize, getLimitRule } from 'oms-js-utils/lib/validation';

export function validateInstrument({ instrument }) {
  if (!instrument) {
    return 'Vennligst velg et instrument å handle på';
  }
}

export function validateLimit({ limit, tickSizeRules }) {
  const normalizedLimit = FormUtils.normalizeNumber(limit);
  const limitPositiveAndPresent = limit && normalizedLimit > 0;
  const validTickSize = isValidTickSize(normalizedLimit, tickSizeRules);

  if (limitPositiveAndPresent && !validTickSize) {
    // Allow empty while we are loading tickSize
    if (!tickSizeRules) {
      return;
    }

    const tickSize = getLimitRule(normalizedLimit, tickSizeRules).accuracy;
    return `Limit: Tick Size er ${tickSize} for dette instrumentet`;
  }

  if (!limitPositiveAndPresent) {
    return 'Ugyldig limit';
  }
}

export function validateVisible({ includeVisible, visible, volume, peakSize }) {
  // Is less than volume and greater than min peakSize
  const normalizedVisible = FormUtils.normalizeNumber(visible);
  const normalizedVolume = FormUtils.normalizeNumber(volume);

  if (includeVisible && !visible) {
    return 'Ugyldig synlig volum';
  }

  if (normalizedVisible >= normalizedVolume) {
    return 'Synlig volum må være mindre enn antall';
  }

  if (normalizedVisible < peakSize) {
    return `Synlig volum må være større enn eller lik ${peakSize}`;
  }
}
